import React, { useEffect, useRef, useState } from 'react';
import { ADSENSE_CLIENT, AdPlacement, CONSENT_EVENT, getAdSlot, getConsent, loadAdsenseScript } from '../../utils/ads';

// Reklamni oglas na unapred određenom mestu. Ne prikazuje ništa dok nije podešen AdSense ID
// i dok korisnik ne prihvati kolačiće. Ne stavljati na prijavu, ekrane kviza, rezultate ni admin.
function AdSlot({ placement, className = '' }: { placement: AdPlacement; className?: string }) {
    const slot = getAdSlot(placement);
    const [allowed, setAllowed] = useState(getConsent() === 'granted');
    const pushed = useRef(false);

    useEffect(() => {
        const onChange = () => setAllowed(getConsent() === 'granted');
        window.addEventListener(CONSENT_EVENT, onChange);
        return () => window.removeEventListener(CONSENT_EVENT, onChange);
    }, []);

    const enabled = !!ADSENSE_CLIENT && !!slot && allowed;

    useEffect(() => {
        if (!enabled || pushed.current) return;
        loadAdsenseScript();
        try {
            ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
            pushed.current = true;
        } catch {
            // AdSense još nije učitan ili je blokiran (adblock) - bez posledica za korisnika
        }
    }, [enabled]);

    if (!enabled) return null;

    return (
        <div className={`w-full flex flex-col items-center my-6 ${className}`}>
            <p className="text-[11px] text-gray-400 mb-1">Reklama</p>
            <ins
                className="adsbygoogle"
                style={{ display: 'block', minHeight: 90, width: '100%' }}
                data-ad-client={ADSENSE_CLIENT}
                data-ad-slot={slot}
                data-ad-format="auto"
                data-full-width-responsive="true"
            />
        </div>
    );
}

export default AdSlot;
